import React from "react";

class Login extends React.Component{
  render(){
    return(
      <div>Login!</div>
    )
  }
}

export default Login;